import React from 'react';
import PropTypes from 'prop-types';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Platform from "react-native-web/dist/exports/Platform";
import Portal from '../Portal';
import { useThemeTokens } from '../ThemeProvider';
import Card from '../Card';
import { jsx as _jsx } from "react/jsx-runtime";
const staticStyles = StyleSheet.create({
  positioner: {
    flex: 1,
    // Grow to maxWidth when possible, shrink when not possible
    position: 'absolute',
    zIndex: 1000000000000000 // Position on top of all the other overlays, including backdrops and modals
  },
  hidden: {
    // Use opacity not visibility to hide the dropdown during positioning
    // so on web, children may be focused from the first render
    opacity: 0
  }
});
const paddingVertical = 0;
const paddingHorizontal = 0;
const DropdownOverlay = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    isReady = false,
    overlaidPosition,
    maxWidth,
    minWidth,
    onLayout,
    tokens
  } = _ref;
  const systemTokens = useThemeTokens('Listbox', {}, {});
  return /*#__PURE__*/_jsx(View, {
    ref: ref,
    onLayout: onLayout,
    style: [overlaidPosition, {
      maxWidth,
      minWidth
    }, staticStyles.positioner, !isReady && staticStyles.hidden],
    children: /*#__PURE__*/_jsx(Card, {
      tokens: {
        shadow: systemTokens.shadow,
        paddingBottom: paddingVertical,
        paddingTop: paddingVertical,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal,
        ...tokens
      },
      children: children
    })
  });
});
const withPortal = Overlay => {
  // eslint-disable-next-line react/display-name, react/no-multi-comp
  return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(Portal, {
    children: /*#__PURE__*/_jsx(Overlay, {
      ...props,
      ref: ref
    })
  }));
};
DropdownOverlay.displayName = 'DropdownOverlay';
DropdownOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  isReady: PropTypes.bool,
  overlaidPosition: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number,
    width: PropTypes.number
  }),
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
  onLayout: PropTypes.func,
  tokens: PropTypes.object
};
export default Platform.OS === 'web' ? withPortal(DropdownOverlay) : DropdownOverlay;